import { Sort } from '@/providers/turn/types';
import { Path } from '@/types/global';
import { OneOffCheckRecord } from '@/types/turn-api';

export const path = (path: Path<OneOffCheckRecord.Base>) => path;

export const SORT_OPTIONS: Sort = { field: '_doc', order: 'DESC' };
